import { Box, styled } from "@mui/material";

export const TopBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",

    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        gap: theme.spacing(4),
        borderBottom: `1px solid ${theme.palette.core.grey._20}`,
        alignItems: "flex-start",
        marginBottom: theme.spacing(6),
    },
}));

export const ContainerBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: theme.spacing(10),

    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

export const LeftBox = styled(Box)(({ theme }) => ({
    flex: 1,
    [theme.breakpoints.up("md")]: {
        width: "calc(100% - 360px)",
    },
}));
